import React, { useEffect, useState } from "react"
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { EditableList } from "../../../compnents/list/EditableList"
import { TableRowSelection } from "antd/lib/table/interface"
import { RecordsYZBAColumns } from "../columns"
import axios from "axios"
import { useHistory } from "react-router-dom"
import { AXIOS_IP, FillingType } from "../fileUploadService"
import { YZBAFormModal } from "./YZBAFormModal"

export const RecordsYZBAModal = (props: {
  visible: boolean
  token: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const [id, setId] = useState<any>()

  const [memo, setMemo] = useState<any>()

  const history = useHistory()

  const [pageLoading, setPageLoading] = useState(false)

  const [YZBAFormVisible, setYZBAFormVisible] = useState(false)

  const [YZBATemporaryVisible, setYZBATemporaryVisible] = useState(false)

  const [YZBAData, setYZBAData] = useState({ isAdjustment: -1, sameNameProcurementCount: '' })
  

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    pageNo: 1,
    pageSize: 10,
  })

  const getData = () => {
    setPageLoading(true)
    axios({
      url: `${AXIOS_IP}/filingReviewFreeClinic/list`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: { ...params },
    }).then((res) => {
      setPage({
        ...page,
        items: res.data.data?.list || [],
        total: res.data.data?.total || 0,
      })
      setPageLoading(false)
    })
  }

  useEffect(() => {
    if (!props.visible) return
    getData()
  }, [props.visible, params])

  return (
    <>
      <Modal
        title="义诊备案申请记录"
        width={1200}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        footer={null}
        centered
        maskClosable={false}
      >
        <div>
          <EditableList
            style={{ flex: 1, height: "450px" }}
            scroll={{ x: "30rem" }}
            page={{
              items: page.items,
              current: params.pageNo,
              size: params.pageSize,
              total: page.total,
            }}
            pageSizeOptions={["10", "20", "50", "100"]}
            loading={pageLoading}
            rowKey={(m: any) => m.id}
            columns={RecordsYZBAColumns(
              params.pageSize * (params.pageNo - 1),
              (action: any, t: any) => {
                switch (action) {
                  case "again":
                    setId(t?.id)
                    setMemo(t?.memo)
                    props.onCancel()
                    setYZBAFormVisible(true)  
                    break
                  case "detail":
                    history.push({
                      pathname: "/filingManagementDetail",
                      state: {
                        id: t.id,
                        state: 2,
                        type: FillingType.YZBA,
                        isFiling: true,
                        isAdjustmentName: t.isAdjustmentName,
                        sameNameProcurementCount: t.sameNameProcurementCount,
                      },
                    })
                    break
                }
              }
            )}
            onChangePage={(current, size) =>
              setParams({ ...params, pageNo: current, pageSize: size || 10 })
            }
            sticky
          />
        </div>
      </Modal>
      
      <YZBAFormModal
        visible={YZBAFormVisible}
        againId={id}
        memo={memo}
        token={props.token}
        onOk={() => {
          setYZBAFormVisible(false)
        }}
        onCancel={() => setYZBAFormVisible(false)}
      />
      
    </>
  )
}
